import { Tooltip } from '@mui/material';
import { Button } from '@trackman/web-shared-components';
import { SessionMode } from 'enums/SessionMode';
import { SessionTaggingState } from 'enums/SessionTaggingState';
import { History } from 'history';
import { IApiArchiveSessionModel, IUploadState, UploadStatus } from 'interfaces/session/IApiArchiveSessionModel';
import React from 'react';
import { ReactComponent as AutoTaggedIcon } from '../../../components/icons/autoTaggedIcon.svg';
import { ReactComponent as FailIcon } from '../../../components/icons/failIcon.svg';
import { ReactComponent as ManualTaggedIcon } from '../../../components/icons/manualTaggedIcon.svg';
import { ReactComponent as PauseIcon } from '../../../components/icons/pauseIcon.svg';
import { ReactComponent as SuccessIcon } from '../../../components/icons/successIcon.svg';
import { Status } from '../ArchivesStyles';
import { SubmitButton } from '../components/SubmitButton/SubmitButton';

export const renderReviewButton = (
  sessionId: string,
  history: History,
  state: SessionTaggingState,
  sessionMode: SessionMode,
  isBattingPractice?: boolean
) => {
  if (sessionMode !== SessionMode.SessionEnded) {
    return <div>{`${sessionMode}`}</div>;
  }
  if (state === SessionTaggingState.SessionSubmittedBySystem || state === SessionTaggingState.SessionSubmittedByTagger) {
    return (
      <Tooltip title='Submitted'>
        <SuccessIcon />
      </Tooltip>
    );
  }
  return (
    <Button
      intent='secondary'
      label='Review'
      onClick={() => history.push((isBattingPractice ? '/review-bp/' : '/review/') + sessionId)}
      width='74px'
    />
  );
};
export const renderVideoUploadStatus = (state?: IUploadState) => {
  let statusDisplay = 'N/A';
  let dot = null;
  if (state) {
    switch (state.playVideoUploadStatus) {
      case UploadStatus.Unknown: {
        statusDisplay = 'Unknown';
        dot = null;
        if (!state.isInternetConnectionAvailable) {
          dot = <FailIcon />;
        }
        break;
      }
      case UploadStatus.InProgress: {
        statusDisplay = 'Pending';
        dot = <PauseIcon />;
        break;
      }
      case UploadStatus.Uploaded: {
        statusDisplay = 'Uploaded';
        dot = <SuccessIcon />;
        break;
      }
      case UploadStatus.NotApplicable: {
        statusDisplay = 'N/A';
        dot = <FailIcon />;
        break;
      }
      default: {
        statusDisplay = 'N/A';
        dot = <FailIcon />;
        break;
      }
    }
  }

  return (
    <Tooltip title={statusDisplay}>
      <div>{dot}</div>
    </Tooltip>
  );
};

export const renderSubmitButton = (session: IApiArchiveSessionModel) => {
  if (
    session.sessionTaggingState.state === SessionTaggingState.SessionSubmittedBySystem ||
    session.sessionTaggingState.state === SessionTaggingState.SessionSubmittedByTagger
  ) {
    return <></>;
  }
  return <SubmitButton session={session} />;
};

export const renderStatus = (state: SessionTaggingState) => {
  let className = '';
  let statusDisplay;
  switch (state) {
    case SessionTaggingState.InitialLineupSet: {
      className += ' not-reviewed';
      statusDisplay = 'Not Reviewed';
      break;
    }
    case SessionTaggingState.SessionAdjustedByCleaner: {
      className += ' submitted';
      statusDisplay = 'Adjusted';
      break;
    }
    case SessionTaggingState.SessionSubmittedBySystem:
    case SessionTaggingState.SessionSubmittedByTagger: {
      className += ' submitted';
      statusDisplay = 'Submitted';
      break;
    }
  }

  return (
    <Status className={className}>
      <span className='dot' />
      {statusDisplay}
    </Status>
  );
};

export const renderTaggedIcon = (isOperatorlessTaggingEnabled: boolean) => {
  return (
    <Tooltip title={isOperatorlessTaggingEnabled ? 'Auto-tag enabled' : 'Manually tagged'}>
      {isOperatorlessTaggingEnabled ? <AutoTaggedIcon /> : <ManualTaggedIcon />}
    </Tooltip>
  );
};
